export const formatImageSource = (
  source: string = '',
  width: number = 0,
  isSquare: boolean = false,
  quality: number = 80,
) => {
  // sanitize image url if it already has a query string
  if (source?.includes('?')) {
    source = source.split('?')[0];
  }

  const squareOption = isSquare ? 'crop=1:1&' : '';

  if (width === 0) {
    return {
      src: source,
      srcSet: source,
    };
  }

  return {
    src: `${encodeURI(
      source,
    )}?${squareOption}quality=${quality}&width=${width}`,
    srcSet: `${encodeURI(
      source,
    )}?${squareOption}quality=${quality}&width=${width} 1x, ${encodeURI(
      source,
    )}?${squareOption}quality=${quality}&width=${Math.floor(width * 1.5)} 2x`,
  };
};
